import { SettingsCard, TextField } from "./fields";
import type { SettingsTabProps } from "../settings";

export default function IletisimSosyal({ settings, update }: SettingsTabProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <SettingsCard
        title="İletişim Bilgileri"
        description="Destek ve iletişim kanalları. İletişim sayfası, e-posta ve bildirimlerde kullanılır."
      >
        <div className="space-y-4">
          <TextField
            label="Destek E-postası"
            type="email"
            value={settings.contactEmail}
            onChange={(v) => update({ contactEmail: v })}
            placeholder="destek@siteniz.com"
          />
          <TextField
            label="Destek Telefonu"
            value={settings.supportPhone}
            onChange={(v) => update({ supportPhone: v })}
            placeholder="+90 216 000 00 00"
          />
          <TextField
            label="WhatsApp"
            value={settings.whatsapp}
            onChange={(v) => update({ whatsapp: v })}
            placeholder="+90 500 000 00 00"
          />
        </div>
      </SettingsCard>

      <SettingsCard
        title="Sosyal Medya"
        description="Sosyal medya hesaplarınız. Footer ve iletişim bölümlerinde bağlantı olarak görünür."
      >
        <div className="space-y-4">
          <TextField
            label="Instagram"
            value={settings.instagram}
            onChange={(v) => update({ instagram: v })}
            placeholder="https://instagram.com/hesap"
          />
          <TextField
            label="X (Twitter)"
            value={settings.twitter}
            onChange={(v) => update({ twitter: v })}
            placeholder="https://x.com/hesap"
          />
          <TextField
            label="YouTube"
            value={settings.youtube}
            onChange={(v) => update({ youtube: v })}
            placeholder="https://youtube.com/@kanal"
          />
          <TextField
            label="LinkedIn"
            value={settings.linkedin}
            onChange={(v) => update({ linkedin: v })}
            placeholder="https://linkedin.com/company/sirket"
          />
        </div>
      </SettingsCard>
    </div>
  );
}